import React from 'react'
import NetworkLogger from 'react-native-network-logger'

const DebugNetworkingScreen: React.FC = () => {
  return <NetworkLogger />
}

export default DebugNetworkingScreen
